/* sts-routine-widget.js: the "My routine" tab and its non-modal panel on
   every page you can shop from (prototype v6.1 §4 [data-rwtab] /
   [data-rwpanel], GL-5; glow §3.6): product, collection, brand, search,
   Deals, a blog article, and the homepage once "Your routine at a glance"
   (.sts-hero__glance) has scrolled out of view. Loaded only by
   snippets/sts-routine-widget.liquid, which those sections render.

   v6.1 §4: the tab drags sideways and snaps to the nearer edge at its own
   height (localStorage 'sts-rw-side', the prototype's key); a desktop-only
   "Move this to the left/right side" link does the same, and the open
   panel follows the side. Rows open their product. The header reads
   "n products · $total + tax", crossed out with the lower price and a note
   when a subscription (its own eachShipment rate) or a cart discount code
   (/cart.js cart_level_discount_applications) takes money off; they stack.
   Simulator: Q+ customer / Q+ stale subscribe at the My subscription
   fixture's rate (15%) unless &sts_sub=none|cancelled|paused, and
   &sts_code=CODE or CODE:25 is a demo code (20% when no rate is given).

   Q+ only: no tab for Q- / Q~. A typed visitor always has a routine, as in
   v6 (STS-ROUTINE-MISSING-1014): with nothing readable the type's default
   stands in (assets/sts-type-routine.js), so a known type never goes tabless.

   Routine source, the Skin Profile's order (assets/sts-profile.js Api.load):
   a routine this page already published (STS.routine.get()), the staff
   simulator fixture (STS.previewRoutine), then for a signed-in customer
   the account's document exactly as the Skin Profile reads it: GET
   {proxy}/profile while saving is on, else /my-regimen + {api}/widget/regimen
   (never the device copy; its legacy adapter needs the Skin Profile's own
   island), else the type's default (STS.typeRoutine.build); for a guest
   STS.typeRoutine.guest: this device's routine, slqSavedRegimen (30 days,
   same type) as the PDP, home glance and article CTA read it, else a saved
   result's token, else the type's default, settled on the device.

   STS.routineWidget, for the Add to my routine flow (v6 6.2 / 6.3):
     open({changedStepIds, badge, badges, steps, focus})
         Opens (re-reading the routine, or rendering `steps` if given). Rows
         whose stepId / extraId / key / variant id is in changedStepIds get a
         badge: badge 'added' -> "Just added" (filled an empty step, new extra
         step), anything else -> "Just updated" (a swap); `badges` maps one id
         to its own. The panel then scrolls to the first changed row if it is
         out of view and it glows 2s through STS.routineChanged.glow (#575),
         both only once no popup covers the page. Focus moves in unless ids were given (the
         page's own confirmation keeps it) or focus:false.
     refresh(steps?)   re-read (or take `steps`) and redraw; badges stay.
     close()           closes; badges clear (v6 6.1).
   It also redraws on `sts:routine:change` {steps}. */
(function (w, d) {
  'use strict';

  var STS = (w.STS = w.STS || {});
  if (STS.routineWidget) return;
  var cfg = d.querySelector('[data-sts-rw]');
  if (!cfg) return;

  function attr(n) { return cfg.getAttribute(n) || ''; }
  function list(n) { return attr(n).split(/\s+/).filter(Boolean); }

  var PAGE = attr('data-page');
  var PROD = PAGE === 'product' ? {
    id: attr('data-product-id'), handle: attr('data-handle'), title: attr('data-title'),
    slots: list('data-slots'), variants: list('data-variants')
  } : null;
  var TYPES = ['DSPT', 'DSNT', 'DSPW', 'DSNW', 'OSPT', 'OSNT', 'OSPW', 'OSNW',
    'ORPT', 'ORNT', 'ORPW', 'ORNW', 'DRPT', 'DRNT', 'DRPW', 'DRNW'];
  /* The step words, by slot family, matched exactly as STSRoutine.core.slotFamily
     does (letters before the digits). Nouns everywhere in the routine since v7.1
     (7.1-031). UI copy, not the category table: another family falls back to
     that table when it is loaded, else to no label. */
  var WORD = { C: 'Cleanser', T: 'Treatment', M: 'Moisturizer', S: 'Sunscreen', SPF: 'Sunscreen', E: 'Eye cream' };
  var MAX_AGE = 30 * 24 * 60 * 60 * 1000;

  var doc = null;         // the routine, toDoc() shape
  var type = null;        // the type it was read for; null = hide everything
  var isOpen = false;
  var badges = {};        // id -> badge text, until close
  /* STS-ROUTINE-MISSING-1014 follow-up: ONE read per type at a time (shared
     by boot and the first open), and `busy` while an open waits on it: the
     panel shows at once with a loading line instead of doing nothing until a
     slow account + price read lands (the first See my routine tap looked
     dead; the second opened). */
  var reading = null, readingT = null, busy = false, closes = 0;
  var tab, panel, head, body, flip, frame = 0, probed = 0;
  var side = lsGet('sts-rw-side') === 'left' ? 'left' : 'right', dragged = false;
  var past = PAGE !== 'home';   // homepage: the glance card has scrolled away
  var subPct = 0, codes = [], offT = 0, sum = null;

  function lsGet(k) { try { return w.localStorage.getItem(k); } catch (e) { return null; } }
  function parse(raw) { try { return raw ? JSON.parse(raw) : null; } catch (e) { return null; } }
  function str(v) { return v == null || v === '' ? '' : String(v).split('/').pop(); }
  function reduced() {
    try { return w.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }
  function phone() {
    try { return w.matchMedia('(max-width: 860px)').matches; } catch (e) { return false; }
  }
  function mk(tag, cls, txt) {
    var n = d.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  }
  function curType() {
    var s = STS.state;
    if (!s || !s.typed) return null;
    var t = String(s.type || d.documentElement.getAttribute('data-sts-type') || '').toUpperCase();
    return TYPES.indexOf(t) > -1 ? t : null;
  }

  // ------------------------------------------------------------------ data

  function envBase(key, fb) {
    var E = STS.env;
    return String((E && E.get) ? E.get(key, fb) : (fb || ''));
  }
  /* 8s deadline, as every routine read in the theme has (sts-routine-shared
     NS.net): a hung fetch must not leave the tab waiting forever. */
  function net(url, opts) {
    var R = w.STSRoutine;
    if (R && R.net) return R.net(url, opts);
    var ctrl = typeof w.AbortController === 'function' ? new w.AbortController() : null;
    var o = Object.assign({}, opts || {});
    if (ctrl) o.signal = ctrl.signal;
    var t = w.setTimeout(function () { if (ctrl) ctrl.abort(); }, 8000);
    return w.fetch(url, o).then(function (r) { w.clearTimeout(t); return r; });
  }
  /* One document shape for every source: {steps, extras, quantities,
     routineSize}, the RoutineDoc sts-profile.js adopts. A flat list (the
     popups' step shape, what sts-add-routine.js hands over) carries its
     Extra steps as extra:true entries; they are split back out here. */
  function toDoc(x) {
    if (!x) return null;
    var list = Array.isArray(x) ? x : (Array.isArray(x.steps) ? x.steps : []);
    var steps = [], extras = (!Array.isArray(x) && Array.isArray(x.extras)) ? x.extras.slice() : [];
    list.forEach(function (s) { if (s && typeof s === 'object') (s.extra ? extras : steps).push(s); });
    if (!steps.length && !extras.length) return null;
    return {
      steps: steps, extras: extras,
      quantities: (!Array.isArray(x) && x.quantities) || null,
      routineSize: (!Array.isArray(x) && x.routineSize) || null
    };
  }
  /* The Skin Profile's read (sts-profile.js Api.loadChain): GET {proxy}/profile
     while saving is on (the theme setting it falls back to), else my-regimen +
     {api}/widget/regimen. */
  function json(r) { return (r.ok && r.status !== 204) ? r.json() : null; }
  function server() {
    var proxy = envBase('proxyBase', attr('data-proxy-base') || '/apps/quiz').replace(/\/+$/, '');
    var api = envBase('apiBase', attr('data-ec2-base')).replace(/\/+$/, '');
    var prof = attr('data-saving') === 'true'
      ? net(proxy + '/profile', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.status === 401 ? null : json(r); }).catch(function () { return null; })
      : Promise.resolve(null);
    return prof.then(function (doc) {
      if (doc && Array.isArray(doc.steps) && doc.steps.length) return toDoc(doc);
      return net(proxy + '/my-regimen', { credentials: 'same-origin' })
        .then(json)
        .then(function (data) {
          if (!data || !data.widgetToken || !api) return null;
          return net(api + '/widget/regimen', { headers: { Authorization: 'Bearer ' + data.widgetToken } })
            .then(json)
            .then(function (p) { return p && Array.isArray(p.steps) ? toDoc(p) : null; });
        });
    }).catch(function () { return null; });
  }
  function cached(t) {
    var c = parse(lsGet('slqSavedRegimen'));
    if (!c || !Array.isArray(c.steps) || !c.steps.length) return null;
    if (c.cachedAt && Date.now() - c.cachedAt > MAX_AGE) return null;
    if (t && c.skinType && String(c.skinType).toUpperCase() !== t) return null;
    return toDoc(c);
  }
  function load(t) {
    var R = STS.routine;
    if (R && typeof R.get === 'function') {
      var got = null;
      try { got = R.withExtras ? R.withExtras() : R.get(); } catch (e) { got = null; }
      if (got && got.length) return Promise.resolve(toDoc(got));
    }
    var pv = typeof STS.previewRoutine === 'function'
      ? STS.previewRoutine().then(function (r) { return r && r.steps && r.steps.length ? toDoc(r) : null; }, function () { return null; })
      : Promise.resolve(null);
    return pv.then(function (s) {
      /* Under a preview: the fixture or none, never the account's or device's. */
      if (s || (STS.preview && STS.preview.active)) return s;
      /* A signed-in customer's routine is the account's, as on the Skin
         Profile; the device copy is a guest's. A known type always has one
         (assets/sts-type-routine.js): a guest's is settled on this device,
         and an account with none shows its type's default. */
      var TR = STS.typeRoutine;
      if (STS.state && STS.state.loggedIn) {
        return server().then(function (x) { return x || (TR && t ? toDoc(TR.build(t)) : null); });
      }
      return TR ? TR.guest(t).then(function (c) { return toDoc(c) || cached(t); }) : cached(t);
    }).then(mkt);
  }
  /* v6.1 13.3: these sources carry the backend's US prices. Outside the
     shop's currency every step and extra is repriced from the market's own
     price list (STS.money.reprice); a routine the Skin Profile published
     above is already priced there. At home nothing changes. */
  function mkt(x) {
    var M = STS.money, F = STS.stepFallback;
    /* QA 2026-10-01: at home too, the live store price over the stored one. */
    if (x && F && F.prices) return Promise.all([F.prices(x.steps), F.prices(x.extras)]).then(function (r) { x.steps = r[0]; x.extras = r[1]; return x; });
    if (!x || !M || !M.reprice || M.code() === M.shop) return x;
    return Promise.all([M.reprice(x.steps), M.reprice(x.extras)]).then(function (r) { x.steps = r[0]; x.extras = r[1]; return x; });
  }

  // --------------------------------------------------------------- shaping

  /* The Skin Profile's rules (sts-routine-shared.js core): a step is filled
     when it has a dtcVariantId AND a title; one bottle = one dtcVariantId. */
  function vid(s) { return str(s.dtcVariantId); }
  function empty(s) { return s.included === false || !s.title || !vid(s); }
  function glowId(s) { return String(s.extra ? (s.extraId || s.key || vid(s)) : (s.stepId || vid(s))); }
  function keys(s) {
    return [s.stepId, s.extraId, s.key, s.dtcVariantId, s.productId, s.variantId, s.id]
      .map(function (k) { return k == null ? '' : String(k); }).filter(Boolean)
      .concat(vid(s) ? [vid(s)] : []);
  }
  /* "Treatment & moisturizer": each step word once, the first capitalised. */
  function joinWords(ws) {
    var t = ws.map(function (x) { return String(x || '').toLowerCase(); })
      .filter(function (x, i, a) { return x && a.indexOf(x) === i; }).join(' & ');
    return t.charAt(0).toUpperCase() + t.slice(1);
  }
  /* famOf: ECS, the eye placeholder, is family E (STS.slotFam). */
  function word(s) {
    var f = famOf(s.slot);
    if (WORD[f]) return WORD[f];
    var C = w.STSRoutine && w.STSRoutine.core;
    return (C && C.categoryForSlot && C.categoryForSlot(s.slot)) || '';
  }
  function price(s) {
    var p = s.priceMsrp != null ? s.priceMsrp : s.price;
    return p === '' || p == null || !isFinite(Number(p)) ? null : Number(p);
  }
  function qty(s, q) {
    var m = q && vid(s) ? (q[vid(s)] || q[String(s.dtcVariantId)]) : 0;
    return Math.max(1, parseInt(m || s.qty || s.quantity, 10) || 1);
  }
  /* sts-profile.js adopt(): a sold-out step shows its top in-stock
     alternative, noted on its row (D32; Luis 2026-10-01). The same rule
     everywhere: core.substituteOutOfStock when the shared module is on the
     page, else assets/sts-step-fallback.js, which that one defers to. */
  function subOut(s) {
    var C = w.STSRoutine && w.STSRoutine.core, F = STS.stepFallback;
    if (C && C.substituteOutOfStock) return C.substituteOutOfStock(Object.assign({}, s));
    return F ? F.standIn(s) : s;
  }
  function money(n) {
    var M = w.STSRoutine && w.STSRoutine.money;
    if (M && M.format) return M.format(n);
    /* v6.1 13.3: the head's STS.money, with the routine totals' house style. */
    return STS.money ? STS.money.format(n, { trim: true }) : '$' + Number(n).toFixed(2);
  }

  /* The Skin Profile's rendering of the same document (sts-profile.js adopt,
     rowsFor, renderRow, addableUnits): steps in routine order, an AM + PM
     step in both columns; a sold-out step shows its same-slot substitute; a
     removed step (included:false) is an "Empty step" row; a Core routine
     hides its non-essential steps; one bottle per dtcVariantId, priced on
     its first live row; "n products · $total" is the buyable bottles (in
     stock, priced) plus Extra steps, times quantity. v7.1 §3 (7.1-045): a
     product used morning and evening is listed once, under "Morning &
     evening" above the two; one in two steps at the same time of day is one
     row named after both ("Treatment & moisturizer"); rows are renumbered. */
  function shape(doc) {
    var Q = {}, qs = (doc && doc.quantities) || {};
    Object.keys(qs).forEach(function (k) { Q[str(k)] = qs[k]; });
    var core = doc && doc.routineSize === 'core';
    var main = ((doc && doc.steps) || []).map(subOut).filter(function (s) {
      return !(core && s.essential === false && s.included !== false);
    });
    var O = STS.orderRoutine;
    var ordered = O ? O(main) : main.map(function (s, i) { return Object.assign({ half: s.time === 'PM' ? 'PM' : 'AM', n: i + 1 }, s); });
    var halves = {};
    ordered.forEach(function (s) {
      if (empty(s)) return;
      var h = halves[vid(s)] || (halves[vid(s)] = {});
      h[s.half === 'PM' ? 'PM' : 'AM'] = 1;
      if (s.time === 'BOTH') { h.AM = 1; h.PM = 1; }
    });
    var seen = {}, units = [], total = 0;
    function unit(s) {
      var v = vid(s);
      if (!v || seen[v]) return;
      seen[v] = 1;
      var p = price(s);
      if (s.title && p != null && s.inStock !== false) { units.push(s); total += p * qty(s, Q); }
    }
    function row(s, isExtra) {
      var blank = isExtra ? (!s.title || !vid(s)) : empty(s), p = price(s), q = qty(s, Q), label = '';
      if (!blank) {
        label = seen[vid(s)] ? 'Incl.' : (p == null ? '' : (q > 1 ? q + ' × ' : '') + money(p));
        unit(s);
      }
      var h = !isExtra && !blank ? halves[vid(s)] : null;
      return { s: s, blank: blank, price: label, shared: !!(h && h.AM && h.PM) };
    }
    var rows = ordered.map(function (s) { return row(s, false); });
    var both = [], am = [], pm = [], at = {};
    rows.forEach(function (r) {
      var v = !r.blank && vid(r.s), k = r.shared ? 'B' : r.s.half === 'PM' ? 'P' : 'A';
      if (v && at[k + v]) { at[k + v].words.push(word(r.s)); return; }
      r.words = [word(r.s)];
      if (v) at[k + v] = r;
      (k === 'B' ? both : k === 'P' ? pm : am).push(r);
    });
    var extras = ((doc && doc.extras) || []).filter(function (e) { return e && e.included !== false; })
      .map(function (e) { return Object.assign({}, e, { extra: true }); });
    var x = extras.map(function (s) { return row(s, true); });
    return {
      both: both, am: am, pm: pm,
      extras: x, count: units.length, total: Math.round(total * 100) / 100, all: ordered.concat(extras)
    };
  }

  /* v6 rwFit: a PDP only, never for a product wrong for this type. In the
     routine already -> "[Name] is in your routine."; else the first step
     (morning first) that Add to my routine would fill: its matcher and its
     step name (STS.addRoutine.match / stepWords, sts-add-routine.js), so the
     note and the Replace popup name the same step. A step matches on the
     product's slot codes, as the server does (ORNW's sunscreen step is S02,
     the EltaMD SPF 46 carries S01 S03 S25 HA04 S26: no step, so it goes in
     as an extra step and gets no note). No row is coloured. The fallbacks
     are the same tiers, for a page without that file: exact code, then
     without a tinted T (S25T -> S25). */
  var FAMW = { C: 'Cleanser', E: 'Eye cream', M: 'Moisturizer', S: 'Sun protection', SPF: 'Sun protection', T: 'Treatment', EX: 'Exfoliant', TN: 'Toner' };
  function famOf(c) { c = String(c || '').toUpperCase(); return /^HA/.test(c) ? c : STS.slotFam ? STS.slotFam(c) : c.replace(/[0-9].*$/, ''); }
  /* The eye placeholder (ECS) stands for any E slot, as a resolved one would. */
  function same(a, b) { return STS.sameSlot ? STS.sameSlot(a, b) : String(a) === String(b); }
  function matchSteps(list, slots) {
    var A = STS.addRoutine;
    if (A && typeof A.match === 'function') return A.match(list, slots);
    var tiers = [function (x) { return x; }, function (x) { return x.replace(/(\d)T$/, '$1'); }];
    for (var i = 0; i < tiers.length; i++) {
      var want = slots.map(tiers[i]);
      var hit = list.filter(function (s) {
        var k = s.slot && tiers[i](String(s.slot).toUpperCase());
        return k && want.some(function (x) { return same(x, k); });
      });
      if (hit.length) return hit;
    }
    return [];
  }
  function stepName(s, shared) {
    var A = STS.addRoutine;
    if (A && typeof A.stepWords === 'function') return A.stepWords(s, shared);
    var l = String((STS.stepLabel ? STS.stepLabel(s) : s.label || s.category) || FAMW[famOf(s.slot)] || 'routine').toLowerCase();
    return (s.half === 'PM' || s.time === 'PM' ? 'evening ' : 'morning ') + l + ' step' + (shared ? ' (AM + PM)' : '');
  }
  function isThis(s) {
    /* v6.1 §5.1: a variant is its own routine item; the size picked now. */
    var sel = d.querySelector('[data-sts-product] [data-sts-variant-input]');
    if (vid(s) && sel && sel.value) return vid(s) === str(sel.value);
    return (!!vid(s) && PROD.variants.indexOf(vid(s)) > -1) ||
      (!!s.handle && String(s.handle).replace(/^\/+/, '') === PROD.handle) ||
      (!!s.productId && str(s.productId) === PROD.id);
  }
  function fitNote(v) {
    if (!PROD || !PROD.slots.length) return '';
    var root = d.querySelector('[data-sts-product]');
    var fit = root ? root.getAttribute('data-sts-fit') : '';
    if (fit !== 'approved') {
      if (fit && fit !== 'unknown') return '';
      var ok = root ? (root.getAttribute('data-sts-approved') || '').split(' ') : [];
      if (ok.indexOf(type) < 0) return '';
    }
    if (v.all.some(function (s) { return !empty(s) && isThis(s); })) return PROD.title + ' is in your routine.';
    var steps = v.all.filter(function (s) { return !s.extra; });
    var hit = matchSteps(steps, PROD.slots)[0];
    if (!hit) return '';
    /* AM + PM: a step used morning and evening, or one bottle in both halves. */
    var shared = hit.time === 'BOTH' || (!empty(hit) && steps.some(function (s) {
      return s !== hit && s.half !== hit.half && !empty(s) && vid(s) === vid(hit);
    }));
    return 'This product fits your ' + stepName(hit, shared) + '.';
  }

  // --------------------------------------------------------------- styles

  var cssOn = false;
  function css() {
    if (cssOn || !d.head) return;
    cssOn = true;
    var st = mk('style');
    st.id = 'sts-rw-css';
    /* Prototype v6 px. Colours: --td -> --sts-type-btn behind white text and
       --sts-type-ink for type text (the AA pair on white and on the tint),
       --tt -> --sts-type-tint; both octagons fill --sts-type-oct under a white
       number (one palette, 2026-10-01), the tab's inside a 2px white ring
       (::before, under the number) so it stands off the -btn tab. z 59
       under the header's 60 so its menus open over the panel. */
    st.textContent = [
      '.sts-rw-tab{position:fixed;right:0;top:50%;z-index:44;display:flex;align-items:center;gap:8px;margin:0;background:var(--sts-type-btn);color:#fff;border:0;border-radius:14px 0 0 14px;padding:10px 14px 10px 10px;font:700 13px/1.2 var(--sts-font);cursor:pointer;box-shadow:0 10px 30px rgba(30,33,64,.22);min-height:48px;animation:stsRwUp .2s ease;touch-action:none;-webkit-user-select:none;user-select:none}',
      /* v6.1 §4: the left edge mirrors the right; while dragged it follows the
         pointer sideways only (left set inline), rounded all round. */
      '.sts-rw-tab[data-side=left]{right:auto;left:0;border-radius:0 14px 14px 0}',
      '.sts-rw-tab[data-drag]{right:auto;border-radius:14px;animation:none}',
      '.sts-rw-tab .sts-rw-tab__oct{box-sizing:border-box;width:26px;height:26px;flex:none;display:flex;align-items:center;justify-content:center;margin:0;padding:0;position:relative;isolation:isolate;background:#fff;color:#fff;font:700 11px/1 var(--sts-font);clip-path:var(--sts-oct-shape,polygon(50% 0%,67% 9%,85% 15%,91% 33%,100% 50%,91% 67%,85% 85%,67% 91%,50% 100%,33% 91%,15% 85%,9% 67%,0% 50%,9% 33%,15% 15%,33% 9%))}',
      '.sts-rw-tab .sts-rw-tab__oct::before{content:"";position:absolute;inset:2px;z-index:-1;clip-path:inherit;background:var(--sts-type-oct)}',
      '.sts-rw-tab:focus-visible{outline:3px solid var(--sts-navy);outline-offset:2px}',
      '.sts-rw-tab[hidden],.sts-rw[hidden]{display:none}',
      'html[data-sts-drawer="open"] .sts-rw-tab,html[data-sts-chrome-open] .sts-rw-tab{visibility:hidden}',
      /* Desktop height (v6.1 §4): calc(100vh - 136px) at the 112px top, and
         94px shorter (100vh - 230px) while the PDP floating add to cart bar
         shows (.sts-rw--bar), so it never overlaps it; a chat launcher in the
         corner is the other floor, whichever is higher. */
      '.sts-rw--bar{--sts-rw-bar:94px}',
      '.sts-rw{position:fixed;right:16px;top:var(--sts-rw-top,112px);width:360px;max-height:calc(100vh - var(--sts-rw-top,112px) - 24px - max(var(--sts-rw-chat,0px),var(--sts-rw-bar,0px)));transition:max-height .25s ease;overflow:auto;overscroll-behavior:contain;z-index:59;box-sizing:border-box;background:#fff;border:1px solid #DBDCDD;border-radius:20px;box-shadow:0 24px 60px rgba(30,33,64,.22);animation:stsRwIn .2s ease;font-family:var(--sts-font);color:#26284a;text-align:left}',
      '.sts-rw__head{position:sticky;top:0;z-index:2;background:#fff;padding:14px 16px 12px;border-bottom:1px solid #EEEEF1;display:flex;align-items:center;gap:10px}',
      /* Its own rule, not the shared .sts-oct: sts-product.css re-sizes that
         class (40px) and sts-collection.css turns it inline-block, which
         dropped the numeral out of its centre on those two page types. */
      '.sts-rw .sts-rw__oct{box-sizing:border-box;width:34px;height:34px;flex:none;display:flex;align-items:center;justify-content:center;margin:0;padding:0;background:var(--sts-type-oct);color:#fff;font:700 12px/1 var(--sts-font);clip-path:var(--sts-oct-shape,polygon(50% 0%,67% 9%,85% 15%,91% 33%,100% 50%,91% 67%,85% 85%,67% 91%,50% 100%,33% 91%,15% 85%,9% 67%,0% 50%,9% 33%,15% 15%,33% 9%))}',
      '.sts-rw__ttl{min-width:0;flex:1}',
      '.sts-rw__h{margin:0;font:700 15.5px/1.3 var(--sts-font);color:#2F3572;letter-spacing:0;text-transform:none}',
      '.sts-rw__h:focus{outline:0}',
      '.sts-rw__sub{margin:0;font-size:12px;line-height:1.4;color:#6E7076;display:flex;gap:6px;align-items:baseline;flex-wrap:wrap}',
      '.sts-rw__was{color:#9A9CA6}',
      '.sts-rw__sale{font-size:14px;font-weight:700;color:#26284a}',
      '.sts-rw__off{flex:1 1 100%;font-size:11.5px;font-weight:600;color:var(--sts-type-ink)}',
      '.sts-rw__x{flex:none;width:38px;height:38px;margin:0;padding:0;border:1px solid #DBDCDD;border-radius:50%;background:#FAFAF8;color:#2F3572;font:400 18px/1 var(--sts-font);cursor:pointer}',
      '.sts-rw__body{padding:12px 16px calc(16px + var(--sts-rw-pad,0px));display:flex;flex-direction:column;gap:6px}',
      '.sts-rw__fit{margin:0 0 4px;font-size:12.5px;font-weight:600;line-height:1.4;color:var(--sts-type-ink);background:var(--sts-type-tint);border-radius:10px;padding:8px 11px;text-wrap:pretty}',
      '.sts-rw__sec{margin:8px 0 0;font-size:11px;font-weight:700;line-height:1.3;letter-spacing:.14em;text-transform:uppercase;color:#6E7076}',
      '.sts-rw__sec--first{margin-top:2px}',
      '.sts-rw__list{display:flex;flex-direction:column;gap:6px;margin:0;padding:0}',
      '.sts-rw__row{display:grid;grid-template-columns:16px 34px minmax(0,1fr) auto;gap:9px;align-items:center;margin:0;background:#fff;border:1.5px solid #EEEEF1;border-radius:12px;padding:7px 9px}',
      '.sts-rw__row--x{grid-template-columns:34px minmax(0,1fr) auto}',
      /* An extra step comes out with × (the Skin Profile editor's .sts-extra__x). */
      '.sts-rw__row--x.sts-rw__row--rm{grid-template-columns:34px minmax(0,1fr) auto 28px}',
      '.sts-rw__rm{width:28px;height:28px;padding:0;border-radius:50%;border:1px solid #E8D5D0;background:#FBF1EE;color:#B4452F;font-size:15px;line-height:1;cursor:pointer}',
      '.sts-rw__rm:hover{background:#F6E2DC}',
      '.sts-rw__rm:focus-visible{outline:2px solid #2F3572;outline-offset:2px}',
      '.sts-rw__rm[disabled]{opacity:.5;cursor:default}',
      '.sts-rw__n{font-size:13px;font-weight:700;color:var(--sts-type-ink)}',
      '.sts-rw__img{display:block;width:34px;height:34px;border-radius:8px;background:#F1F1F3;object-fit:contain}',
      '.sts-rw__txt{min-width:0}',
      '.sts-rw__lbl{display:flex;gap:6px;align-items:center;flex-wrap:wrap;font-size:11px;line-height:1.35;color:#6E7076}',
      '.sts-rw__badge{font-size:10px;font-weight:700;line-height:1.4;color:#fff;background:var(--sts-type-btn);border-radius:999px;padding:1px 7px;white-space:nowrap}',
      /* The image and name open the product (prototype r.view). Hover only
         darkens slightly, as the v6.1 §4 handoff text says (not the
         prototype's lighter opacity .78): the image at brightness(.92), the
         name one step darker than its --sts-ink rest (#1E2140, the shadow
         navy). No underline, no icon; an empty step is a plain span. */
      '.sts-rw__go{grid-column:span 2;display:grid;grid-template-columns:34px minmax(0,1fr);gap:9px;align-items:center;min-width:0;border-radius:8px;color:#26284a;text-decoration:none}',
      'a.sts-rw__go:hover{color:#1E2140;text-decoration:none}',
      'a.sts-rw__go:hover .sts-rw__img{filter:brightness(.92)}',
      'a.sts-rw__go:focus-visible,.sts-rw__flip:focus-visible{outline:2px solid #2F3572;outline-offset:2px}',
      '.sts-rw__name{display:block;font-size:12.5px;font-weight:600;color:inherit;line-height:1.25;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}',
      '.sts-rw__oos{display:block;margin-top:2px;font-size:11px;line-height:1.35;color:#8a5b00}',
      '.sts-rw__price{font-size:12.5px;font-weight:600;color:#26284a;white-space:nowrap}',
      '.sts-rw__edit{display:flex;align-items:center;justify-content:center;box-sizing:border-box;margin-top:10px;background:#fff;color:#2F3572;border:1.5px solid #2F3572;border-radius:999px;padding:11px 18px;font:600 13.5px/1.2 var(--sts-font);min-height:44px;text-decoration:none;cursor:pointer}',
      '.sts-rw__edit:hover{background:#EEF0F8;color:#2F3572}',
      '.sts-rw__loading{margin:6px 0;font-size:13px;line-height:1.4;color:#6E7076}',
      '.sts-rw__x:focus-visible,.sts-rw__edit:focus-visible{outline:2px solid #2F3572;outline-offset:2px}',
      '.sts-rw__flip{align-self:center;margin:0;background:none;border:0;padding:8px 4px;min-height:40px;cursor:pointer;color:#6E7076;font:600 12.5px/1.2 var(--sts-font);text-decoration:underline;text-underline-offset:3px}',
      '@media (min-width:861px){.sts-rw[data-side=left]{right:auto;left:16px}}',
      '@keyframes stsRwUp{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}',
      '@keyframes stsRwIn{from{transform:translateX(30px);opacity:0}to{transform:none;opacity:1}}',
      /* ≤860px: a bottom sheet on the bottom menu with 10px under its content
         (v6.1 1.5, full-width bars), and the tab at the prototype's phone
         place, bottom:calc(190px + safe area) on every page (v6.1 L162;
         top:50% is desktop only). PDP: only while the floating add to cart
         bar is OPEN ([data-bar], barWatch) and its top edge (bottom menu +
         --sts-sticky-h) is above that, the tab rises just enough to clear it
         by 12px; folded to the ▴ pill, or not shown yet, it stays at 190. */
      '@media (max-width:860px){' +
        '.sts-rw-tab{top:auto;bottom:calc(190px + env(safe-area-inset-bottom,0px))}' +
        '.sts-rw-tab[data-bar]{bottom:max(calc(190px + env(safe-area-inset-bottom,0px)),calc(var(--sts-bottom-offset,0px) + var(--sts-sticky-h,0px) + 12px))}' +
        '.sts-rw-tab[data-foot],.sts-rw-tab[data-cta]{visibility:hidden}' +
        '.sts-rw{top:auto;bottom:var(--sts-bottom-offset,env(safe-area-inset-bottom,0px));left:0;right:0;width:100%;max-height:62vh;border-radius:20px 20px 0 0}' +
        '.sts-rw__body{padding-bottom:calc(10px + var(--sts-rw-pad,0px))}' +
        '.sts-rw__x{width:44px;height:44px}' +
        /* The sheet covers the tab there, so the move would not be seen: phones drag it. */
        '.sts-rw__flip{display:none}}',
      /* ≤749px (Marla, 2026-10-14: "bigger so the images and font are
         bigger"): the sheet runs to 12px under the top of the screen,
         pictures 76px, names 17px over up to three lines instead of one cut
         short, labels 13px, prices 17px, close 48px and remove 44px. It sits
         one over the header (z 61): the header block is up to ~226px tall on
         a PDP (announcement, search, sign-in strip) and at 59 it covered the
         sheet's own title and close button. The page is scroll-locked while
         it is open (data-sts-scroll-lock), and the bottom menu (200), the
         cart drawer (81) and popups stay above it. */
      '@media (max-width:749px){' +
        '.sts-rw{z-index:61;max-height:calc(100vh - var(--sts-bottom-offset,0px) - 12px - env(safe-area-inset-top,0px));max-height:calc(100dvh - var(--sts-bottom-offset,0px) - 12px - env(safe-area-inset-top,0px));box-shadow:0 -12px 40px rgba(30,33,64,.28)}' +
        '.sts-rw__head{padding:14px 16px 12px;gap:12px}' +
        '.sts-rw .sts-rw__oct{width:40px;height:40px;font-size:14px}' +
        '.sts-rw__h{font-size:20px}' +
        '.sts-rw__sub{font-size:15px}' +
        '.sts-rw__sale{font-size:17px}' +
        '.sts-rw__off{font-size:13.5px}' +
        '.sts-rw__x{width:48px;height:48px;font-size:22px}' +
        '.sts-rw__body{gap:8px}' +
        '.sts-rw__fit{font-size:15px;padding:10px 12px}' +
        '.sts-rw__sec{font-size:13px;margin-top:12px}' +
        '.sts-rw__list{gap:8px}' +
        '.sts-rw__row{grid-template-columns:20px 76px minmax(0,1fr) auto;gap:10px;padding:10px;border-radius:14px}' +
        '.sts-rw__row--x{grid-template-columns:76px minmax(0,1fr) auto}' +
        '.sts-rw__row--x.sts-rw__row--rm{grid-template-columns:76px minmax(0,1fr) auto 44px;gap:8px}' +
        '.sts-rw__go{grid-template-columns:76px minmax(0,1fr);gap:10px}' +
        '.sts-rw__img{width:76px;height:76px;border-radius:12px}' +
        '.sts-rw__n{font-size:15px}' +
        '.sts-rw__lbl{font-size:13px;gap:4px 6px}' +
        '.sts-rw__badge{font-size:12px;padding:1px 8px}' +
        '.sts-rw__name{font-size:17px;line-height:1.3;margin-top:2px;white-space:normal;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3;overflow-wrap:anywhere}' +
        '.sts-rw__oos{font-size:13px}' +
        '.sts-rw__price{font-size:17px}' +
        '.sts-rw__rm{width:44px;height:44px;font-size:20px}' +
        '.sts-rw__edit{font-size:16px;min-height:48px}}',
      '@media (prefers-reduced-motion:reduce){.sts-rw-tab,.sts-rw{animation:none;transition:none}}',
      '@media print{.sts-rw-tab,.sts-rw{display:none!important}}'
    ].join('');
    d.head.appendChild(st);
  }

  // ---------------------------------------------------------------- markup

  function build() {
    tab = mk('button', 'sts-rw-tab');
    tab.type = 'button';
    tab.hidden = true;
    tab.setAttribute('data-page', PAGE);
    tab.setAttribute('aria-label', 'Show my routine');
    tab.setAttribute('aria-expanded', 'false');
    tab.setAttribute('aria-controls', 'sts-rw-panel');
    tab.title = 'Drag to the other side of the screen to move it';
    tab.appendChild(mk('span', 'sts-rw-tab__oct')).setAttribute('aria-hidden', 'true');
    tab.appendChild(d.createTextNode('My routine'));
    tab.addEventListener('click', function () { if (!dragged) open({ focus: true }); });
    tab.addEventListener('pointerdown', drag);

    panel = mk('aside', 'sts-rw');
    panel.id = 'sts-rw-panel';
    panel.hidden = true;
    panel.setAttribute('aria-label', 'My routine');
    /* v6.2 §1.1: the phone sheet locks the page behind it (assets/sts-scroll.js). */
    panel.setAttribute('data-sts-scroll-lock', '860');
    head = mk('div', 'sts-rw__head');
    var oct = head.appendChild(mk('span', 'sts-rw__oct'));
    oct.setAttribute('aria-hidden', 'true');
    var ttl = head.appendChild(mk('div', 'sts-rw__ttl'));
    ttl.appendChild(mk('h2', 'sts-rw__h')).tabIndex = -1;
    ttl.appendChild(mk('p', 'sts-rw__sub'));
    var x = head.appendChild(mk('button', 'sts-rw__x', '×'));
    x.type = 'button';
    x.setAttribute('aria-label', 'Close');
    x.addEventListener('click', function () { close(true); });
    panel.appendChild(head);
    body = panel.appendChild(mk('div', 'sts-rw__body'));
    /* Built once and re-appended by render(), so a flip keeps its focus. */
    flip = mk('button', 'sts-rw__flip');
    flip.type = 'button';
    flip.addEventListener('click', function () { setSide(side === 'left' ? 'right' : 'left', true); });
    setSide(side);
    if (PAGE === 'product') { barWatch(); ctaWatch(); }
    footWatch();
    /* Esc from inside the panel (or with nothing focused) closes it; a popup
       owns its own Esc. Not a focus trap: the panel is non-modal. */
    d.addEventListener('keydown', function (e) {
      if (!isOpen || (e.key !== 'Escape' && e.key !== 'Esc')) return;
      if (d.querySelector('dialog[open]')) return;
      var a = d.activeElement;
      if (a && a !== d.body && !panel.contains(a)) return;
      close(true);
    });
    d.body.appendChild(tab);
    d.body.appendChild(panel);
  }

  function rowNode(r, n, isExtra) {
    var s = r.s;
    /* A div, as the prototype's row is: theme.css list rules cannot put a
       marker into the grid. */
    var li = mk('div', 'sts-rw__row' + (isExtra ? ' sts-rw__row--x' : ''));
    li.setAttribute('data-sts-glow-id', glowId(s));
    if (!isExtra) li.appendChild(mk('span', 'sts-rw__n', String(n)));
    var url = r.blank ? '' : href(s);
    var go = li.appendChild(mk(url ? 'a' : 'span', 'sts-rw__go'));
    if (url) go.href = url;
    /* Never an empty square (sts-step-fallback.js): the step's picture, the
       product's looked up, else the step-category icon. */
    var F = STS.stepFallback, src = !r.blank && (s.image || s.imageUrl || s.image_url);
    var img = go.appendChild(src || F ? mk('img', 'sts-rw__img') : mk('span', 'sts-rw__img'));
    if (src || F) {
      img.alt = r.blank ? '' : s.displayTitle || s.title || '';
      img.width = 34;
      img.height = 34;
      img.loading = 'lazy';
      img.decoding = 'async';
      /* 76px on a phone (≤749px) at up to 3x wants a larger file than 34px. */
      var px = phone() && w.innerWidth <= 749 ? 240 : 96;
      if (F) F.paint(img, r.blank ? { slot: s.slot } : s, px);
      else img.src = String(src).indexOf('cdn.shopify.com') > -1 && !/[?&]width=/.test(src) ? src + (String(src).indexOf('?') > -1 ? '&' : '?') + 'width=' + px : src;
    }
    var txt = go.appendChild(mk('span', 'sts-rw__txt'));
    var lbl = txt.appendChild(mk('span', 'sts-rw__lbl'));
    lbl.appendChild(d.createTextNode(isExtra ? (s.brand || '') : joinWords(r.words || [word(s)])));
    var b = null;
    keys(s).some(function (k) { b = badges[k]; return !!b; });
    if (b) {
      lbl.appendChild(mk('span', 'sts-rw__badge', b));
      li.setAttribute('data-sts-rw-just', '');
    }
    /* The variant's name, "Title (Variant)" (displayTitle, #1055), else the title. */
    txt.appendChild(mk('span', 'sts-rw__name', r.blank ? 'Empty step' : s.displayTitle || s.title));
    /* The stand-in for a sold-out product says so (Luis, 2026-10-01). */
    if (!r.blank && F && s.substituted === true && s.substitutedFrom) txt.appendChild(mk('span', 'sts-rw__oos', F.note(s)));
    li.appendChild(mk('span', 'sts-rw__price', r.price));
    var A = STS.addRoutine;
    if (isExtra && !r.blank && s.extraId && A && typeof A.removeExtra === 'function') {
      li.className += ' sts-rw__row--rm';
      var rm = li.appendChild(mk('button', 'sts-rw__rm', '×'));
      rm.type = 'button';
      rm.setAttribute('aria-label', 'Remove extra step ' + (s.displayTitle || s.title || ''));
      rm.addEventListener('click', function () {
        rm.disabled = true;
        A.removeExtra(s.extraId).then(function (ok) { if (!ok) rm.disabled = false; });
      });
    }
    return li;
  }

  function section(title, rows, first, isExtra) {
    body.appendChild(mk('p', 'sts-rw__sec' + (first ? ' sts-rw__sec--first' : ''), title));
    var ul = body.appendChild(mk('div', 'sts-rw__list'));
    rows.forEach(function (r, i) { ul.appendChild(rowNode(r, i + 1, isExtra)); });
  }

  function render() {
    var v = shape(doc);
    var n = TYPES.indexOf(type) + 1;
    tab.firstChild.textContent = String(n);
    head.firstChild.textContent = String(n);
    head.querySelector('.sts-rw__h').textContent = 'Your ' + type + ' routine';
    sum = v;
    paintSum();
    /* A row rebuilt mid-glow carries on (as sts-profile.js). */
    var lit = {};
    [].forEach.call(body.querySelectorAll('[data-sts-glow][data-sts-glow-id]'), function (r) {
      if (r.__stsGlowAt) lit[r.getAttribute('data-sts-glow-id')] = r.__stsGlowAt;
    });
    body.textContent = '';
    var note = fitNote(v);
    if (note) body.appendChild(mk('p', 'sts-rw__fit', note));
    if (v.both.length) section('Morning & evening', v.both, true, false);
    section('Morning', v.am, !v.both.length, false);
    section('Evening', v.pm, false, false);
    if (v.extras.length) section('Extra steps', v.extras, false, true);
    [].forEach.call(body.querySelectorAll('[data-sts-glow-id]'), function (r) {
      var at = lit[r.getAttribute('data-sts-glow-id')], gone = at ? Date.now() - at : 2100;
      if (gone >= 2100) return;
      r.__stsGlowAt = at;
      r.style.animationDelay = -gone + 'ms';
      r.setAttribute('data-sts-glow', '');
      setTimeout(function () { r.removeAttribute('data-sts-glow'); }, 2100 - gone);
    });
    var url = (attr('data-profile-url') || '/pages/skin-profile') + '#my-routine';
    var edit = body.appendChild(mk('a', 'sts-rw__edit', 'Edit in my Skin Profile'));
    edit.href = STS.keepPreview ? STS.keepPreview(url) : url;
    body.appendChild(flip);
  }

  /* "n products · $total + tax"; with a discount the total is crossed out,
     the lower price follows and the note takes its own line (prototype
     rwShop / rwSale / rwSaleNote). */
  function paintSum() {
    var el = head && head.querySelector('.sts-rw__sub');
    if (!el || !sum) return;
    var o = offers(sum.total);
    el.textContent = '';
    el.appendChild(mk('span', null, (sum.count === 1 ? '1 product' : sum.count + ' products') + ' ·'));
    if (!o) { el.appendChild(mk('span', null, money(sum.total) + ' + tax')); return; }
    el.appendChild(mk('span', 'sts-visually-hidden', 'Was'));
    el.appendChild(mk('s', 'sts-rw__was', money(sum.total)));
    el.appendChild(mk('span', 'sts-visually-hidden', 'now'));
    el.appendChild(mk('span', 'sts-rw__sale', money(o.sale)));
    el.appendChild(mk('span', null, '+ tax'));
    el.appendChild(mk('span', 'sts-rw__off', o.note));
  }

  // ------------------------------------------------------------- placement

  /* Desktop: below the header (the prototype's 112px once the header has
     scrolled away, 16px under it while it shows) and clear of a chat
     launcher in the bottom-right corner (Gorgias today): the panel ends 12px
     above it. Phone: the sheet keeps its place and pads its end instead, so
     "Edit in my Skin Profile" can always scroll above the launcher. */
  function launcherTop() {
    var x = w.innerWidth - 40, vh = w.innerHeight, top = null, y, i;
    function check(el) {
      if (!el || el === d.documentElement || el === d.body || panel.contains(el) || el === tab) return;
      if (el.closest && el.closest('.sts-sticky-min,.sts-totop,.sts-bnav,[data-sts-sticky]')) return;
      if (w.getComputedStyle(el).position !== 'fixed') return;
      var r = el.getBoundingClientRect();
      if (r.width > w.innerWidth * 0.6 || r.height > vh * 0.5 || r.bottom < vh - 200) return;
      top = top == null ? r.top : Math.min(top, r.top);
    }
    for (y = vh - 10; y > vh - 200; y -= 20) {
      var hits = d.elementsFromPoint ? d.elementsFromPoint(x, y) : [];
      for (i = 0; i < hits.length; i++) check(hits[i]);
    }
    return top;
  }
  function place() {
    frame = 0;
    if (!isOpen) return;
    var h = d.querySelector('[data-sts-header]');
    var hb = h ? h.getBoundingClientRect().bottom : 0;
    panel.style.setProperty('--sts-rw-top', Math.max(112, Math.round(hb) + 16) + 'px');
    var now = Date.now();
    if (now - probed < 500) return;
    probed = now;
    var lt = launcherTop(), vh = w.innerHeight, need;
    if (phone()) {
      need = lt == null ? 0 : Math.max(0, Math.round(panel.getBoundingClientRect().bottom - lt + 12));
      panel.style.setProperty('--sts-rw-pad', need + 'px');
      panel.style.setProperty('--sts-rw-chat', '0px');
    } else {
      need = lt == null ? 0 : Math.max(0, Math.round(vh - 24 - lt + 12));
      panel.style.setProperty('--sts-rw-chat', need + 'px');
      panel.style.setProperty('--sts-rw-pad', '0px');
    }
  }
  function schedule() { if (isOpen && !frame) frame = w.requestAnimationFrame(place); }
  w.addEventListener('scroll', schedule, { passive: true });
  w.addEventListener('resize', function () { probed = 0; schedule(); });

  /* Homepage (v6.1 §4): the tab only once the glance card's bottom is above
     the header (or the top of the window), hidden again on the way back up.
     No card on screen (none rendered, or hidden) counts as scrolled past. */
  var gFrame = 0;
  function pastNow() {
    /* v7: the Routine milestones box takes the glance card's place
       (snippets/sts-milestones-box.liquid, data-sts-glance-anchor). */
    var g = [].filter.call(d.querySelectorAll('.sts-hero__glance, [data-sts-glance-anchor]'), function (x) { return x.getClientRects().length; })[0];
    var h = d.querySelector('[data-sts-header]');
    return !g || g.getBoundingClientRect().bottom < Math.max(0, h ? h.getBoundingClientRect().bottom : 0);
  }
  function glance() {
    gFrame = 0;
    var p = pastNow();
    if (p !== past) { past = p; if (tab && type && doc) showHide(); }
  }
  if (PAGE === 'home') {
    w.addEventListener('scroll', function () { if (!gFrame) gFrame = w.requestAnimationFrame(glance); }, { passive: true });
  }

  // ----------------------------------------------------------- left / right

  function setSide(sd, save) {
    side = sd === 'left' ? 'left' : 'right';
    if (save) { try { w.localStorage.setItem('sts-rw-side', side); } catch (e) { /* blocked: this visit only */ } }
    tab.setAttribute('data-side', side);
    panel.setAttribute('data-side', side);
    flip.textContent = side === 'left' ? 'Move this to the right side' : 'Move this to the left side';
  }
  /* Past 6px sideways the tab follows the pointer (prototype rwTabDown); on
     release it snaps to the nearer edge. Only `left` changes, never the
     height, and the click that ends a drag does not open the panel. */
  function drag(e) {
    if (e.button > 0) return;
    var sx = e.clientX, moved = false;
    function mv(ev) {
      if (!moved && Math.abs(ev.clientX - sx) <= 6) return;
      moved = true;
      tab.setAttribute('data-drag', '');
      tab.style.left = Math.max(0, Math.min(w.innerWidth - tab.offsetWidth, ev.clientX - 60)) + 'px';
    }
    function up(ev) {
      w.removeEventListener('pointermove', mv);
      w.removeEventListener('pointerup', up);
      w.removeEventListener('pointercancel', up);
      if (!moved) return;
      tab.removeAttribute('data-drag');
      tab.style.left = '';
      dragged = true;
      w.setTimeout(function () { dragged = false; }, 80);
      if (ev.type === 'pointerup') setSide(ev.clientX < w.innerWidth / 2 ? 'left' : 'right', true);
    }
    w.addEventListener('pointermove', mv);
    w.addEventListener('pointerup', up);
    w.addEventListener('pointercancel', up);
  }

  /* PDP: the floating add to cart bar's own state (sts-product.js initSticky
     data-shown, false while it is folded into the pill): the desktop panel's
     shorter height, and the phone tab's lift over the open bar. .sts-sticky:
     the header, first in the page, has data-sts-sticky too (QA on #650). */
  function barWatch() {
    var bar = d.querySelector('.sts-sticky[data-sts-sticky]');
    if (!bar || !w.MutationObserver) return;
    var f = function () {
      var on = bar.getAttribute('data-shown') === 'true';
      panel.classList.toggle('sts-rw--bar', on);
      tab.toggleAttribute('data-bar', on);
    };
    new w.MutationObserver(f).observe(bar, { attributes: true, attributeFilter: ['data-shown'] });
    f();
  }
  /* Phones: the tab never covers a footer control (the region select, the
     accordions' +/−): it hides, keeping its side, once the footer's top is
     above 190px from the bottom (early for a lifted tab), back on the way up. */
  function footWatch() {
    var f = d.querySelector('[data-sts-footer]');
    if (!f || !w.IntersectionObserver) return;
    new w.IntersectionObserver(function (es) {
      tab.toggleAttribute('data-foot', es[es.length - 1].isIntersecting);
    }, { rootMargin: '0px 0px -190px 0px' }).observe(f);
  }

  /* Phones, PDP: the tab never covers a buy button either ("Add to cart
     only" ran under it, signed-in QA 2026-10-20 D6). While one of the buy
     box's buttons passes behind it the tab hides, keeping its side, as it
     does over the footer, and comes back once the button is clear. */
  function ctaWatch() {
    var box = d.querySelector('.sts-buy__ctas');
    if (!box) return;
    var fr = 0;
    function chk() {
      fr = 0;
      var t = tab.getBoundingClientRect(), hit = false, bs, r, i;
      if (phone() && t.height) {
        bs = box.querySelectorAll('.sts-btn');
        for (i = 0; i < bs.length && !hit; i++) {
          r = bs[i].getBoundingClientRect();
          hit = r.height > 0 && r.bottom > t.top - 8 && r.top < t.bottom + 8 && r.right > t.left && r.left < t.right;
        }
      }
      tab.toggleAttribute('data-cta', hit);
    }
    function sch() { if (!fr) fr = w.requestAnimationFrame(chk); }
    w.addEventListener('scroll', sch, { passive: true });
    w.addEventListener('resize', sch);
    /* The tab shows late (once the routine has loaded): check then too. */
    if (w.MutationObserver) new w.MutationObserver(sch).observe(tab, { attributes: true, attributeFilter: ['hidden', 'data-bar'] });
    sch();
  }

  /* Rows open their product, as the Skin Profile links a row (its handle). */
  function href(s) {
    var h = s.handle ? String(s.handle).replace(/^\/+/, '') : '';
    var u = h ? '/products/' + h : (/^\/(?!\/)/.test(String(s.url || '')) ? String(s.url) : '');
    return u && STS.keepPreview ? STS.keepPreview(u) : u;
  }

  // ------------------------------------------------------------- discounts

  /* The subscription's own rate (My subscription's "n% off": eachShipment
     savings over compareAt), then each cart code; percentages multiply, a
     fixed amount comes off after. */
  function offers(total) {
    var m = subPct ? 1 - subPct / 100 : 1, amt = 0, note = subPct ? ['Subscription ' + subPct + '% off'] : [];
    codes.forEach(function (c) {
      if (c.pct) m *= 1 - c.pct / 100; else amt += c.amt;
      note.push(c.code + ' ' + (c.pct ? c.pct + '% off' : money(c.amt) + ' off'));
    });
    var sale = Math.max(0, Math.round((total * m - amt) * 100) / 100);
    return note.length && total > 0 && sale < total ? { sale: sale, note: note.join(' + ') } : null;
  }
  function subFrom(p) {
    var es = (p && p.eachShipment) || {};
    subPct = p && p.hasSubscription && p.status === 'active' && es.compareAt > 0 && es.savings > 0
      ? Math.round(es.savings / es.compareAt * 100) : 0;
    paintSum();
  }
  function param(k) {
    var m = new RegExp('[?&]' + k + '=([^&#]*)').exec(w.location.search);
    try { return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return ''; }
  }
  /* Read when the tab first shows and again (at most every 5s) on open. */
  function offersLoad() {
    var now = Date.now();
    if (now - offT < 5000) return;
    offT = now;
    var P = STS.preview, row = P && P.active && P.selection ? P.selection.row : null;
    if (row) {
      var c = /^([\w-]{1,40})(?::([1-9]\d?))?$/.exec(param('sts_code'));
      subPct = /^q(customer|stale)$/.test(row) && !/(^|,)(none|cancelled|paused)(,|$)/.test(param('sts_sub')) ? 15 : 0;
      codes = c ? [{ code: c[1].toUpperCase(), pct: +(c[2] || 20) }] : [];
      paintSum();
      return;
    }
    var C = STS.consent;
    if (C && C.read && C.subscriber && STS.state && STS.state.loggedIn && C.subscriber()) {
      C.read().then(subFrom, function () { /* no rate shown; a change reads again */ });
    }
    net('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(json).then(function (cart) {
      codes = ((cart && cart.cart_level_discount_applications) || []).filter(function (a) {
        return a && a.type === 'discount_code' && a.title && +a.value > 0;
      }).map(function (a) {
        var n = Math.round(+a.value * 100) / 100;
        return a.value_type === 'percentage' ? { code: String(a.title).toUpperCase(), pct: n } : { code: String(a.title).toUpperCase(), amt: n };
      });
      paintSum();
    }).catch(function () { /* the plain total stays */ });
  }
  d.addEventListener('sts:subscription:updated', function (e) { if (e.detail && e.detail.subscription && !(STS.preview && STS.preview.active)) subFrom(e.detail.subscription); });

  // ------------------------------------------------------------ behaviour

  function sync() {
    var ok = !!type && (!!doc || busy);
    if (!ok) {
      if (tab) { tab.hidden = true; panel.hidden = true; }
      isOpen = false;
      return;
    }
    if (!tab) { css(); build(); offersLoad(); }
    if (doc) { panel.removeAttribute('aria-busy'); render(); } else loadingView();
    if (PAGE === 'home') past = pastNow();
    showHide();
  }
  function showHide() {
    tab.hidden = isOpen || !past;
    tab.setAttribute('aria-expanded', String(isOpen));
    /* The homepage keeps the TAB back until the glance card has gone; an
       open() (See my routine on the hero) shows the panel there at once. */
    panel.hidden = !isOpen;
  }

  /* Once no popup covers the page (v6 3.6: after the customer's choice). */
  function afterPopups(fn) {
    var P = STS.popups, n = 0;
    (function go() {
      if (P && P.busy && P.busy() && ++n < 400) { w.setTimeout(go, 150); return; }
      fn();
    }());
  }

  function badgeText(b) {
    b = String(b || '').toLowerCase();
    return b === 'added' || b === 'just added' || b === 'add' ? 'Just added' : 'Just updated';
  }

  function open(o) {
    o = o || {};
    var ids = (o.changedStepIds || o.ids || []).map(String).filter(Boolean);
    if (ids.length) {
      ids.forEach(function (id) {
        badges[id] = badgeText(o.badges && o.badges[id] != null ? o.badges[id] : o.badge);
      });
    }
    var focus = o.focus != null ? !!o.focus : !ids.length;
    var shut = null;
    var given = o.steps ? toDoc(o.extras ? { steps: o.steps, extras: o.extras } : o.steps) : null;
    var got;
    if (given) got = Promise.resolve(given);
    else if (ids.length) got = load(type || curType());
    else if (doc) got = Promise.resolve(doc);
    else {
      /* Nothing read yet: the panel now, its rows when the read lands. */
      shut = closes;
      if (!type) type = curType();
      if (type) { busy = true; isOpen = true; sync(); place(); if (focus) focusHead(); }
      got = type ? readFor(type) : Promise.resolve(null);
    }
    return got.then(function (x) {
      if (!type) type = curType();
      if (x) doc = x;
      if (busy) busy = false;
      /* Closed while it loaded: the routine is kept, the panel stays shut. */
      if (shut != null && shut !== closes) { if (doc) ready(); return !!doc; }
      if (!type || !doc) { if (isOpen && !doc) { isOpen = false; sync(); } return false; }
      ready();
      isOpen = true;
      probed = 0;
      sync();
      place();
      offersLoad();
      if (focus) focusHead();
      if (ids.length) {
        afterPopups(function () {
          var rows = [].slice.call(panel.querySelectorAll('[data-sts-rw-just]'));
          if (!rows.length || !isOpen) return;
          /* v6.1 §4: scroll only when the changed row is out of view,
             behind the sticky head included. */
          var pr = panel.getBoundingClientRect(), er = rows[0].getBoundingClientRect(), hd = head.offsetHeight;
          if (er.top < pr.top + hd || er.bottom > pr.bottom) {
            var top = Math.max(0, panel.scrollTop + er.top - pr.top - hd - 12);
            if (panel.scrollTo) panel.scrollTo({ top: top, behavior: reduced() ? 'auto' : 'smooth' });
            else panel.scrollTop = top;
          }
          var RC = STS.routineChanged;
          if (RC && RC.glow) RC.glow(rows.map(function (r) { return r.getAttribute('data-sts-glow-id'); }));
        });
      }
      return true;
    });
  }

  function close(returnFocus) {
    if (!isOpen) return;
    var inside = panel.contains(d.activeElement);
    isOpen = false;
    busy = false;
    closes++;
    badges = {};
    sync();
    if ((returnFocus || inside) && !tab.hidden) tab.focus();
  }

  function refresh(s) {
    var given = s ? toDoc(s) : null;
    var got = given ? Promise.resolve(given) : load(type || curType());
    return got.then(function (x) { if (x) { doc = x; ready(); } sync(); return !!doc; });
  }

  function focusHead() {
    var h = head && head.querySelector('.sts-rw__h');
    if (!h) return;
    try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); }
  }
  /* The panel before its rows: the type's header and a loading line. */
  function loadingView() {
    var n = TYPES.indexOf(type) + 1;
    tab.firstChild.textContent = String(n);
    head.firstChild.textContent = String(n);
    head.querySelector('.sts-rw__h').textContent = 'Your ' + type + ' routine';
    head.querySelector('.sts-rw__sub').textContent = '';
    panel.setAttribute('aria-busy', 'true');
    body.textContent = '';
    body.appendChild(mk('p', 'sts-rw__loading', 'Loading your routine…')).setAttribute('role', 'status');
  }
  function readFor(t) {
    if (reading && readingT === t) return reading;
    readingT = t;
    var p = reading = load(t).then(function (x) { if (reading === p) reading = null; return x; },
      function () { if (reading === p) reading = null; return null; });
    return p;
  }
  /* sts:routine:ready {type, steps, extras}: the routine this widget shows,
     for the home glance tiles when nothing on the server or the device draws
     them (assets/sts-home.js); current() is the same for a late reader. */
  function ready() {
    if (!doc || !type) return;
    try { d.dispatchEvent(new CustomEvent('sts:routine:ready', { detail: { type: type, steps: doc.steps, extras: doc.extras } })); } catch (e) { /* old engine */ }
  }

  function onState() {
    var t = curType();
    if (t === type) return;
    type = t;
    doc = null;
    isOpen = false;
    busy = false;
    badges = {};
    sync();
    if (!t) return;
    readFor(t).then(function (x) {
      if (type !== t) return;
      doc = x || null;
      if (!doc && busy) return;   // the waiting open() closes it
      sync();
      ready();
    });
  }

  STS.routineWidget = { open: open, refresh: refresh, close: function () { close(false); },
    current: function () { return doc && type ? { type: type, steps: doc.steps, extras: doc.extras } : null; } };
  /* A row, type or routine picked in the simulator lands now, same type or not. */
  d.addEventListener('sts:preview', function () { type = null; onState(); });

  d.addEventListener('sts:routine:change', function (e) {
    var det = (e && e.detail) || {};
    var x = det.steps ? toDoc(det.extras ? { steps: det.steps, extras: det.extras } : det.steps) : null;
    if (x && type) { doc = x; sync(); }
  });

  function boot() {
    if (typeof STS.onState === 'function') STS.onState(onState);
    else onState();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot);
  else boot();
}(window, document));
